// eslint-disable-next-line import/prefer-default-export
export const baseUrl = import.meta.env.VITE_BASE_URL;
